import React from "react";
import { GrClose } from "react-icons/gr";
import { Form, Button } from "react-bootstrap";

const FilterComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ display: "flex" }}>
        <Form.Control
          type="text"
          placeholder="Filter By Name"
          aria-label="Search Input"
          value={filterText}
          onChange={onFilter}
        />
        <div
          style={{ padding: "5px", backgroundColor: "#f0f0f0" }}
          onClick={onClear}
        >
          <GrClose size="20"></GrClose>
        </div>
      </div>
    </>
  );

export default FilterComponent;
